import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, InputAdornment, Modal, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../../common/table/CommonTable";
import { fetchOrganizations, deleteOrganization, resetCurrentOrganization } from "../../redux/organization/organizationAction.jsx";

const ListOrganization = () => {
  const [loading, setLoading] = useState(true);
  const [openDeleteModel, setopenDeleteModel] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteId, setdeleteId] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const organizationList = useSelector(
    (state) => state?.organization?.fetchListOrganizations || {}
  );
  const [data, setData] = useState([]);

  const fetchData = (page) => {
    const payload = {
      pageNo: page,
      pagesize: 10,
      pagination_required: true,
    };
    dispatch(fetchOrganizations(payload));
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, dispatch]);

  useEffect(() => {
    if (organizationList.data && Array.isArray(organizationList.data.data)) {
      const formattedData = organizationList.data.data.map((org) => ({
        id: org.id,
        org_name: org.org_name,
        hospital_name: org.hospital_name,
        email: org.email,
        phone: org.phone,
        city: org.city,
        address: org.address,
        createdAt: org.createdAt,
      }));
      setData(formattedData);
      setFilteredData(formattedData);
    } else {
      setData([]);
      setFilteredData([]);
    }
  }, [organizationList]);

  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredData(data);
    } else {
      const lowercasedTerm = searchTerm.toLowerCase();
      const filtered = data.filter(org => 
        org.org_name?.toLowerCase().includes(lowercasedTerm) ||
        org.hospital_name?.toLowerCase().includes(lowercasedTerm) ||
        org.email?.toLowerCase().includes(lowercasedTerm) ||
        org.phone?.toLowerCase().includes(lowercasedTerm) ||
        org.city?.toLowerCase().includes(lowercasedTerm)
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, data]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const columns = [
    {
      id: "org_name",
      label: "Organization Name",
      sortable: true,
      render: (value, row) => (
        <Typography
          component="span"
          sx={{
            cursor: "pointer",
            color: "dodgerblue",
            "&:hover": {
              textDecoration: "underline",
            },
          }}
          onClick={() => handleViewClick(row)}
        >
          {value}
        </Typography>
      ),
    },
    { id: "hospital_name", label: "Hospital Name", sortable: true },
    { id: "email", label: "Email", sortable: true },
    { id: "phone", label: "Phone", sortable: true },
    { id: "city", label: "City", sortable: true },
    {
      id: "createdAt",
      label: "Created Date",
      sortable: true,
      render: (value) => {
        const date = new Date(value);
        return isNaN(date) ? "N/A" : date.toLocaleDateString();
      },
    },
  ];

  const handleViewClick = (row) => {
    navigate(`/organization/view/${row.id}`);
  };

  const handleEditClick = (row) => {
    navigate(`/organization/edit/${row.id}`);
  };

  const handleDeleteClick = (row) => {
    setdeleteId(row.id);
    setopenDeleteModel(true);
  };

  const handleDeleteConfirm = () => {
    setData(data.filter((item) => item.id !== deleteId));
    setFilteredData(filteredData.filter((item) => item.id !== deleteId));
    dispatch(deleteOrganization(deleteId));
    setopenDeleteModel(false);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = organizationList.data?.totalPages || 1;

  return (
    <Box>
       <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
            <Button 
                variant="contained" 
                onClick={() => navigate('/organization/add')}
                sx={{ backgroundColor: '#000', color: '#fff', '&:hover': { backgroundColor: '#333' } }}
            >
                Add Organization
            </Button>
        </Box>
      <Box sx={{ mb: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search organizations..."
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>
      <ReusableTable
        title="Organizations"
        columns={columns}
        data={filteredData}
        isLoading={organizationList.loading}
        headerColor="#000"
        rowColor="#ffffff"
        alternateRowColor="#f5f5f5"
        onViewClick={handleViewClick}
        onEditClick={handleEditClick}
        onDeleteClick={handleDeleteClick}
        withPagination={true}
        withActions={true}
        showDownloadOption={true}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
      <Modal
        open={openDeleteModel}
        style={{ left: "35%", top: "35%" }}
        onClose={() => {
          setopenDeleteModel(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ width: "500px", background: " #fff", padding: "20px" }}>
          <Typography
            id="modal-modal-title"
            variant="h5"
            sx={{ fontSize: "large", fontWeight: "500" }}
            component="h2"
          >
            Delete Organization
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to delete this organization?
          </Typography>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
          >
            <Button variant="contained" onClick={handleDeleteConfirm}>
              OK
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setopenDeleteModel(false);
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default ListOrganization;
